import React from 'react';
import { Place, PlaceFilters } from '../../../app/models/Place';
import DefaultDataTable from '../../../components/default/DefaultDataTable';
import ButtonTableAction from '../../../components/buttons/ButtonTableAction';
import PlaceFilter from './PlaceFilter';

interface Props {
    places: Place[];
    edit?: (PlaceId: number) => void;
    destroy?: (PlaceId: number) => void;
    show?: (DailyPlaceId: number) => void;
    loading?: boolean;
    filter: PlaceFilters;
    setFilter: (filter: PlaceFilters) => void;
    totalRows: number;
}

const PlaceDataTable = ({
    places,
    edit,
    destroy,
    loading = false,
    show,
    filter,
    setFilter,
    totalRows
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row?.id,
            sortable: true,
            sortField: 'id'
        },
        {
            name: 'Nombre',
            selector: (row: any) => row?.name,
            sortable: true,
            sortField: 'name'
        },
        {
            name: 'País',
            selector: (row: any) => row?.country ?? '',
            sortable: true,
            sortField: 'country'
        },
        {
            name: 'Latitud',
            selector: (row: any) => row?.latitude,
            sortable: false,
            sortField: 'latitude'
        },
        {
            name: 'Longitud',
            selector: (row: any) => row?.longitude,
            sortable: false,
            sortField: 'longitude'
        },
        {
            name: 'Acciones',
            selector: (row: any) => row?.id,
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <div className="nowrap-cell nowrap-cell-no-min">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <div>
            <div className="col-12 mt-md-0 mt-3">
                <div className="row">
                    <div className="col-auto">
                        <PlaceFilter filter={filter} setFilter={setFilter} />
                    </div>
                </div>
            </div>
            <div className="col-12 mt-4">
                <DefaultDataTable
                    columns={columns}
                    data={places}
                    progressPending={loading}
                    paginationTotalRows={totalRows}
                    filter={filter}
                    setFilter={setFilter}
                />
            </div>
        </div>
    );
};

export default PlaceDataTable;
